import React from "react";

const CreateUser = React.lazy(() => import("./CreateUser"));
const Index = React.lazy(() => import("./index"));
const UserDetails = React.lazy(() => import("./UserDetails"));
const UserUpdate = React.lazy(() => import("./UpdateUser"));
const UserAddress = React.lazy(() => import("./CreateUserAddress"));

export const userRoutes = [
	{
		path: "/admin/users",
		name: "Users",
		element: <Index />,
	},
	{
		path: "/admin/users/create",
		name: "Create or Update Users",
		element: <CreateUser />,
	},
	{
		path: "/admin/users/update/:id?",
		name: "Create or Update Users",
		element: <CreateUser />,
	},
	{
		path: "/admin/users/:id",
		name: "User",
		element: <UserDetails />,
	},
	{
		path: "/admin/users/address/create",
		name: "User Address",
		element: <UserAddress />,
	},
	{
		path: "/admin/users/address/update/:userId?",
		name: "User Address",
		element: <UserAddress />,
	},
	// {
	// 	path: "/admin/users/update/:id",
	// 	exact: true,
	// 	name: "Update User",
	// 	element:UserUpdate,
	// }
];
